// auto-generated by Typewriter template _enums.tst from PortCall.Models\PortCall\PortCallChange.cs
export enum LineTimeActualField { 
    FirstLineActual = 0,
    LastLineActual = 1
}

export const LineTimeActualFieldDisplayName : { [val : number] : string } = { 
    0: 'FirstLineActual',
    1: 'LastLineActual'
}

export const LineTimeActualFields : { Id : LineTimeActualField, Name : string }[] = [ 
    { Id: LineTimeActualField.FirstLineActual, Name: 'FirstLineActual' },
    { Id: LineTimeActualField.LastLineActual, Name: 'LastLineActual' }
]

export enum InvitedEditorPortCallChangeAction { 
    Add = 0,
    Remove = 1
}

export const InvitedEditorPortCallChangeActionDisplayName : { [val : number] : string } = { 
    0: 'Add',
    1: 'Remove'
}

export const InvitedEditorPortCallChangeActions : { Id : InvitedEditorPortCallChangeAction, Name : string }[] = [ 
    { Id: InvitedEditorPortCallChangeAction.Add, Name: 'Add' },
    { Id: InvitedEditorPortCallChangeAction.Remove, Name: 'Remove' }
]

export enum WatcherPortCallChangeAction { 
    Start = 0,
    Stop = 1
}

export const WatcherPortCallChangeActionDisplayName : { [val : number] : string } = { 
    0: 'Start',
    1: 'Stop'
}

export const WatcherPortCallChangeActions : { Id : WatcherPortCallChangeAction, Name : string }[] = [ 
    { Id: WatcherPortCallChangeAction.Start, Name: 'Start' },
    { Id: WatcherPortCallChangeAction.Stop, Name: 'Stop' }
]

export enum CreationRecipient { 
    RequestorAndAgent = 0,
    BerthManager = 1
}

export const CreationRecipientDisplayName : { [val : number] : string } = { 
    0: 'RequestorAndAgent',
    1: 'BerthManager'
}

export const CreationRecipients : { Id : CreationRecipient, Name : string }[] = [ 
    { Id: CreationRecipient.RequestorAndAgent, Name: 'RequestorAndAgent' },
    { Id: CreationRecipient.BerthManager, Name: 'BerthManager' }
]



// WEBPACK FOOTER //
// ./server/enums/PortCallChange.ts